// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBsfodYxRKeaWqYDjsNG1gNbn0c4zDVWDk",
  authDomain: "medicp-56009.firebaseapp.com",
  projectId: "medicp-56009",
  storageBucket: "medicp-56009.appspot.com",
  messagingSenderId: "198628194918",
  appId: "1:198628194918:web:cdddb7b9880ab2154a8ba7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;